var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"create",scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('content-header')]},proxy:true}])},[_c('el-row',{attrs:{"type":"flex","justify":"left"}},[_c('configs-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }